export default {
  noActiveRecipe: 'No active recipe on this furnace.',
  confirmSave: {
    header: 'Save setpoints?',
    message: 'The setpoints are uploaded to the furnace, and its current setpoints are reset to these values.',
  },
};
